import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/admin/add-client/[id]/contract-obligations/page";

export const Route = createFileRoute(
  "/admin/add-client/$clientId/contract-obligations",
)({
  component: Page,
});
